/**
 * TB-App API – Generated by orval 🍺
 * Do not edit manually.
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';
import { keepPreviousData, useMutation, useQuery, useSuspenseQuery } from '@tanstack/react-query';
import type { BodyType, ErrorType } from '../../axios';
import { request } from '../../axios';
import type {
  AddressContactDto,
  AddressDto,
  ContactWithAddressDto,
  GetAddressContactsParams,
  GetAddressesParams,
  GetAllContactsListParams,
  SetAddressContactStatusParams,
  SetAddressStatusParams,
} from '.././model';
import { PaginatedResponse, PaginationParams } from '../pagination/pagination.types';

type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];

export const setAddressStatus = (
  id: string,
  params: SetAddressStatusParams,
  options?: SecondParameter<typeof request>,
) => {
  return request<void>({ url: `/api/addresses/${id}/status`, method: 'PUT', params }, options);
};

export const getSetAddressStatusMutationOptions = <
  TData = Awaited<ReturnType<typeof setAddressStatus>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; params: SetAddressStatusParams }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['setAddressStatus'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAddressStatus>>,
    { id: string; params: SetAddressStatusParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return setAddressStatus(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; params: SetAddressStatusParams },
    TContext
  >;
};

export type SetAddressStatusMutationResult = NonNullable<Awaited<ReturnType<typeof setAddressStatus>>>;

export type SetAddressStatusMutationError = ErrorType<unknown>;

export const useSetAddressStatus = <
  TData = Awaited<ReturnType<typeof setAddressStatus>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; params: SetAddressStatusParams }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; params: SetAddressStatusParams }, TContext> => {
  const mutationOptions = getSetAddressStatusMutationOptions(options);

  return useMutation(mutationOptions);
};
export const setAddressContactStatus = (
  id: string,
  params: SetAddressContactStatusParams,
  options?: SecondParameter<typeof request>,
) => {
  return request<void>({ url: `/api/addresses/contacts/${id}/status`, method: 'PUT', params }, options);
};

export const getSetAddressContactStatusMutationOptions = <
  TData = Awaited<ReturnType<typeof setAddressContactStatus>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; params: SetAddressContactStatusParams }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['setAddressContactStatus'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setAddressContactStatus>>,
    { id: string; params: SetAddressContactStatusParams }
  > = (props) => {
    const { id, params } = props ?? {};

    return setAddressContactStatus(id, params, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; params: SetAddressContactStatusParams },
    TContext
  >;
};

export type SetAddressContactStatusMutationResult = NonNullable<Awaited<ReturnType<typeof setAddressContactStatus>>>;

export type SetAddressContactStatusMutationError = ErrorType<unknown>;

export const useSetAddressContactStatus = <
  TData = Awaited<ReturnType<typeof setAddressContactStatus>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; params: SetAddressContactStatusParams }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; params: SetAddressContactStatusParams }, TContext> => {
  const mutationOptions = getSetAddressContactStatusMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getAddresses = (
  params?: GetAddressesParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<AddressDto[]>({ url: `/api/addresses`, method: 'GET', params, signal }, options);
};

export const getGetAddressesQueryKey = (params?: GetAddressesParams) => {
  return [`/api/addresses`, ...(params ? [params] : [])] as const;
};

export const getGetAddressesQueryOptions = <
  TData = Awaited<ReturnType<typeof getAddresses>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAddressesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAddressesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddresses>>> = ({ signal }) =>
    getAddresses(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAddresses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAddressesQueryResult = NonNullable<Awaited<ReturnType<typeof getAddresses>>>;
export type GetAddressesQueryError = ErrorType<unknown>;

export function useGetAddresses<TData = Awaited<ReturnType<typeof getAddresses>>, TError = ErrorType<unknown>>(
  params: undefined | GetAddressesParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAddresses<TData = Awaited<ReturnType<typeof getAddresses>>, TError = ErrorType<unknown>>(
  params?: GetAddressesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>> &
    Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAddresses<TData = Awaited<ReturnType<typeof getAddresses>>, TError = ErrorType<unknown>>(
  params?: GetAddressesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetAddresses<TData = Awaited<ReturnType<typeof getAddresses>>, TError = ErrorType<unknown>>(
  params?: GetAddressesParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAddressesQueryOptions(params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAddressesSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getAddresses>>,
  TError = ErrorType<unknown>,
>(
  params?: GetAddressesParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAddressesQueryKey(params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddresses>>> = ({ signal }) =>
    getAddresses(params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getAddresses>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAddressesSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAddresses>>>;
export type GetAddressesSuspenseQueryError = ErrorType<unknown>;

export function useGetAddressesSuspense<TData = Awaited<ReturnType<typeof getAddresses>>, TError = ErrorType<unknown>>(
  params: undefined | GetAddressesParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAddressesSuspense<TData = Awaited<ReturnType<typeof getAddresses>>, TError = ErrorType<unknown>>(
  params?: GetAddressesParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAddressesSuspense<TData = Awaited<ReturnType<typeof getAddresses>>, TError = ErrorType<unknown>>(
  params?: GetAddressesParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetAddressesSuspense<TData = Awaited<ReturnType<typeof getAddresses>>, TError = ErrorType<unknown>>(
  params?: GetAddressesParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAddresses>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAddressesSuspenseQueryOptions(params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createAddress = (
  addressDto: BodyType<AddressDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/addresses`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: addressDto,
      signal,
    },
    options,
  );
};

export const getCreateAddressMutationOptions = <
  TData = Awaited<ReturnType<typeof createAddress>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<AddressDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createAddress'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<Awaited<ReturnType<typeof createAddress>>, { data: BodyType<AddressDto> }> = (
    props,
  ) => {
    const { data } = props ?? {};

    return createAddress(data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { data: BodyType<AddressDto> },
    TContext
  >;
};

export type CreateAddressMutationResult = NonNullable<Awaited<ReturnType<typeof createAddress>>>;
export type CreateAddressMutationBody = BodyType<AddressDto>;
export type CreateAddressMutationError = ErrorType<unknown>;

export const useCreateAddress = <
  TData = Awaited<ReturnType<typeof createAddress>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { data: BodyType<AddressDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { data: BodyType<AddressDto> }, TContext> => {
  const mutationOptions = getCreateAddressMutationOptions(options);

  return useMutation(mutationOptions);
};
export const getAddressContacts = (
  id: string,
  params?: GetAddressContactsParams,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<AddressContactDto[]>({ url: `/api/addresses/${id}/contacts`, method: 'GET', params, signal }, options);
};

export const getGetAddressContactsQueryKey = (id: string, params?: GetAddressContactsParams) => {
  return [`/api/addresses/${id}/contacts`, ...(params ? [params] : [])] as const;
};

export const getGetAddressContactsQueryOptions = <
  TData = Awaited<ReturnType<typeof getAddressContacts>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetAddressContactsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressContacts>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAddressContactsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddressContacts>>> = ({ signal }) =>
    getAddressContacts(id, params, requestOptions, signal);

  return { queryKey, queryFn, enabled: !!id, ...queryOptions } as UseQueryOptions<
    Awaited<ReturnType<typeof getAddressContacts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAddressContactsQueryResult = NonNullable<Awaited<ReturnType<typeof getAddressContacts>>>;
export type GetAddressContactsQueryError = ErrorType<unknown>;

export function useGetAddressContacts<
  TData = Awaited<ReturnType<typeof getAddressContacts>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: undefined | GetAddressContactsParams,
  options: {
    query: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressContacts>>, TError, TData>> &
    Pick<DefinedInitialDataOptions<Awaited<ReturnType<typeof getAddressContacts>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAddressContacts<
  TData = Awaited<ReturnType<typeof getAddressContacts>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetAddressContactsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressContacts>>, TError, TData>> &
    Pick<UndefinedInitialDataOptions<Awaited<ReturnType<typeof getAddressContacts>>, TError, TData>, 'initialData'>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAddressContacts<
  TData = Awaited<ReturnType<typeof getAddressContacts>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetAddressContactsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressContacts>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetAddressContacts<
  TData = Awaited<ReturnType<typeof getAddressContacts>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetAddressContactsParams,
  options?: {
    query?: Partial<UseQueryOptions<Awaited<ReturnType<typeof getAddressContacts>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAddressContactsQueryOptions(id, params, options);

  const query = useQuery(queryOptions) as UseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const getGetAddressContactsSuspenseQueryOptions = <
  TData = Awaited<ReturnType<typeof getAddressContacts>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetAddressContactsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAddressContacts>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey = queryOptions?.queryKey ?? getGetAddressContactsQueryKey(id, params);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getAddressContacts>>> = ({ signal }) =>
    getAddressContacts(id, params, requestOptions, signal);

  return { queryKey, queryFn, ...queryOptions } as UseSuspenseQueryOptions<
    Awaited<ReturnType<typeof getAddressContacts>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetAddressContactsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof getAddressContacts>>>;
export type GetAddressContactsSuspenseQueryError = ErrorType<unknown>;

export function useGetAddressContactsSuspense<
  TData = Awaited<ReturnType<typeof getAddressContacts>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params: undefined | GetAddressContactsParams,
  options: {
    query: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAddressContacts>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAddressContactsSuspense<
  TData = Awaited<ReturnType<typeof getAddressContacts>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetAddressContactsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAddressContacts>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };
export function useGetAddressContactsSuspense<
  TData = Awaited<ReturnType<typeof getAddressContacts>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetAddressContactsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAddressContacts>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

export function useGetAddressContactsSuspense<
  TData = Awaited<ReturnType<typeof getAddressContacts>>,
  TError = ErrorType<unknown>,
>(
  id: string,
  params?: GetAddressContactsParams,
  options?: {
    query?: Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof getAddressContacts>>, TError, TData>>;
    request?: SecondParameter<typeof request>;
  },
): UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {
  const queryOptions = getGetAddressContactsSuspenseQueryOptions(id, params, options);

  const query = useSuspenseQuery(queryOptions) as UseSuspenseQueryResult<TData, TError> & {
    queryKey: DataTag<QueryKey, TData, TError>;
  };

  query.queryKey = queryOptions.queryKey;

  return query;
}

export const createAddressContact = (
  id: string,
  addressContactDto: BodyType<AddressContactDto>,
  options?: SecondParameter<typeof request>,
  signal?: AbortSignal,
) => {
  return request<string>(
    {
      url: `/api/addresses/${id}/contacts`,
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      data: addressContactDto,
      signal,
    },
    options,
  );
};

export const getCreateAddressContactMutationOptions = <
  TData = Awaited<ReturnType<typeof createAddressContact>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<AddressContactDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}) => {
  const mutationKey = ['createAddressContact'];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createAddressContact>>,
    { id: string; data: BodyType<AddressContactDto> }
  > = (props) => {
    const { id, data } = props ?? {};

    return createAddressContact(id, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions } as UseMutationOptions<
    TData,
    TError,
    { id: string; data: BodyType<AddressContactDto> },
    TContext
  >;
};

export type CreateAddressContactMutationResult = NonNullable<Awaited<ReturnType<typeof createAddressContact>>>;
export type CreateAddressContactMutationBody = BodyType<AddressContactDto>;
export type CreateAddressContactMutationError = ErrorType<unknown>;

export const useCreateAddressContact = <
  TData = Awaited<ReturnType<typeof createAddressContact>>,
  TError = ErrorType<unknown>,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<TData, TError, { id: string; data: BodyType<AddressContactDto> }, TContext>;
  request?: SecondParameter<typeof request>;
}): UseMutationResult<TData, TError, { id: string; data: BodyType<AddressContactDto> }, TContext> => {
  const mutationOptions = getCreateAddressContactMutationOptions(options);

  return useMutation(mutationOptions);
};


export const getAddressContactsList = (
  params: PaginationParams = { page: 0, size: 20 },
  signal?: AbortSignal,
) => {
  return request<PaginatedResponse<AddressContactDto>>({
    url: '/api/addresses/contacts',
    method: 'GET',
    params,
    signal,
  });
};

export const getAddressContactsListQueryKey = (params: PaginationParams = { page: 0, size: 20 }) =>
  ['/api/addresses/contacts', params] as const;

export const useAddressContactsList = <
  TData = PaginatedResponse<AddressContactDto>,
  TError = ErrorType<unknown>,
>(
  params: PaginationParams = { page: 0, size: 20 },
) => {
  return useQuery<PaginatedResponse<AddressContactDto>, TError, TData>({
    queryKey: getAddressContactsListQueryKey(params),
    queryFn: ({ signal }) => getAddressContactsList(params, signal),
    placeholderData: keepPreviousData,
  });
};

export const getAllContactsList = (
  params?: GetAllContactsListParams,
  signal?: AbortSignal,
) => {
  return request<ContactWithAddressDto[]>({
    url: '/api/addresses/contacts/list',
    method: 'GET',
    params,
    signal,
  });
};

export const getGetAllContactsListQueryKey = (params?: GetAllContactsListParams) =>
  ['/api/addresses/contacts/list', ...(params ? [params] : [])] as const;

export const useGetAllContactsList = <
  TData = ContactWithAddressDto[],
  TError = ErrorType<unknown>,
>(
  params?: GetAllContactsListParams,
  options?: { query?: Partial<UseQueryOptions<ContactWithAddressDto[], TError, TData>> },
) => {
  const { query: queryOptions } = options ?? {};
  return useQuery<ContactWithAddressDto[], TError, TData>({
    queryKey: getGetAllContactsListQueryKey(params),
    queryFn: ({ signal }) => getAllContactsList(params, signal),
    ...queryOptions,
  });
};